import React, { useEffect, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../redux/store";
import { Grid, Typography, Box } from "@mui/material";
import PageContainer from "../layouts/PageContainer";
import AppCircularProgress from "../components/common/AppCircularProgress";
import SequenceCard from "../components/sequences/SequenceCard";
import { getSequences } from "../redux/actions/sequenceActions";
import PageError from "../components/common/PageError";

const SequencesPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const {
    items: sequences,
    loading: loadingSequences,
    error: errorLoadingSequences,
  } = useAppSelector((state) => state.sequence);

  const fetchSequences = useCallback(() => {
    dispatch(getSequences());
  }, [dispatch]);

  useEffect(() => {
    fetchSequences();
  }, [fetchSequences]);

  const renderContent = (): React.JSX.Element => {
    if (loadingSequences) return <AppCircularProgress />;

    if (errorLoadingSequences) {
      return (
        <PageError error={errorLoadingSequences} onRetry={fetchSequences} />
      );
    }

    if (!sequences || sequences.length === 0) {
      return (
        <Box sx={{ mt: 5, textAlign: "center" }}>
          <Typography>No sequences found.</Typography>
        </Box>
      );
    }

    return (
      <Grid container spacing={3}>
        {sequences.map((seq) => (
          <Grid key={seq.id} size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <SequenceCard sequence={seq} />
          </Grid>
        ))}
      </Grid>
    );
  };

  return (
    <PageContainer
      title="Document Sequences"
      subtitle="View the current numbering sequences for all system documents."
    >
      {renderContent()}
    </PageContainer>
  );
};

export default SequencesPage;
